/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { PartnersContext, usePartnersContext } from './partners-context'
import type * as Fetcher from './partners-fetcher'
import { partnersFetch } from './partners-fetcher'
import type * as Schemas from './partners-schemas'

export type PartnersRequestListPathParams = {
  templateBasePath: string
}

export type PartnersRequestListHeaders = {
  ['X-Locale']?: string
}

export type PartnersRequestListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type PartnersRequestListVariables = {
  headers?: PartnersRequestListHeaders
  pathParams: PartnersRequestListPathParams
} & PartnersContext['fetcherOptions']

/**
 * Returns the list of the Partners
 */
export const fetchPartnersRequestList = (variables: PartnersRequestListVariables, signal?: AbortSignal) =>
  partnersFetch<
    Schemas.Partners,
    PartnersRequestListError,
    undefined,
    PartnersRequestListHeaders,
    {},
    PartnersRequestListPathParams
  >({
    url: '/{templateBasePath}/pages/partners',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the list of the Partners
 */
export const usePartnersRequestList = <TData = Schemas.Partners>(
  variables: PartnersRequestListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.Partners, PartnersRequestListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = usePartnersContext(options)
  return reactQuery.useQuery<Schemas.Partners, PartnersRequestListError, TData>({
    queryKey: queryKeyFn({
      path: '/{templateBasePath}/pages/partners',
      operationId: 'partnersRequestList',
      variables,
    }),
    queryFn: ({ signal }) => fetchPartnersRequestList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation = {
  path: '/{templateBasePath}/pages/partners'
  operationId: 'partnersRequestList'
  variables: PartnersRequestListVariables
}
